import React from "react";
import environments from "../../../../environments";
import { StandardAturizacaoAberturaTumulo } from "./providers/standard";
import { IpirangaAturizacaoAberturaTumulo } from "./providers/ipiranga";

export const AutorizacaoAberturaTumulo: React.FC = () => {
    switch (environments.client.name) {
        case "ipiranga":
            return <IpirangaAturizacaoAberturaTumulo />;
        default:
            return <StandardAturizacaoAberturaTumulo />;
    }
};
